<template>
	<div class="Sharebox">
		<Tou></Tou>

		<!-- ========== Banner ========== -->
		<div class="Sharebox_top" :style="'background: url('+require('@/assets/pc/share/banner-bg.jpg')+') no-repeat center/cover'">
			<div class="Sharebox_top_inner">
				<div class="Sharebox_top_left wow fadeInUp">
					<div class="Sharebox_top_left_btn Sharebox_btn"><span>Ambassador Benefit</span></div>
					<div class="Sharebox_top_left_titles">
						<div class="B-600 f-85 montserBold ys-33 Sharebox_top_line">Share Your</div>
						<div class="B-600 f-85 montserBold ys-33 Sharebox_top_line">Expertise</div>
						<div class="B-600 f-85 montserBold Sharebox_top_left_title Sharebox_top_line">Earn 500 Points</div>
					</div>
					<div class="Sharebox_top_left_desc">
						<div class="B-300 f-20 montserLight ys-66">Turn your GoodWe installations and solution insights into</div>
						<div class="B-300 f-20 montserLight ys-66">valuable rewards. Create and share engaging GoodWe</div>
						<div class="B-300 f-20 montserLight ys-66">solutions-based video content, and get credited.</div>
					</div>
					<div class="Sharebox_top_submit">
						<img :src="require('@/assets/pc/share/shipin.png')" class="submit_icon" alt="" />
						<span class="submit_text">Submit Your Video</span>
					</div>
					<div class="Sharebox_top_note">
						<img :src="require('@/assets/pc/share/gantan.png')" class="note_icon" alt="" />
						<span class="montserMedium">For Installers:</span>
						<span class="B-300 f-16 montserLight note_text ml-8">GoodWe PLUS+ Member Exclusive</span>
					</div>
				</div>
				<div class="Sharebox_top_right wow fadeInUp" data-wow-delay=".3s">
					<img :src="require('@/assets/pc/share/banner-img.png')" class="banner_img" alt="banner" />
				</div>
			</div>
		</div>

		<!-- ========== Section 2: How It Works ========== -->
		<div class="how_section">
			<div class="how_tag wow fadeInUp montserRegular"><span>How It Works</span></div>
			<div class="how_title B-500 f-48 montserMedium ys-33 wow fadeInUp" data-wow-delay=".1s">Turn Your Expertise Into Rewards</div>
			<div class="how_steps flex">
				<div class="how_step wow fadeInUp" data-wow-delay=".2s" v-for="(s,i) in steps" :key="i">
					<div class="step_circle">
						<img :src="s.icon" :class="'step_icon'+i" alt="" />
					</div>
					<div class="step_num montserLight">{{s.num}}</div>
					<div class="step_title f-22 montserBold ys-33">{{s.title}}</div>
					<div class="step_desc f-16 montserLight ys-66">{{s.desc}}</div>
				</div>
			</div>
		</div>

		<!-- ========== Section 3: What Can You Share? ========== -->
		<div class="share_section" :style="'background: url('+require('@/assets/pc/share/bg2.jpg')+') no-repeat center/cover'">
			<div class="share_title B-500 f-48 montserMedium ys-33 wow fadeInUp">What Can You Share?</div>
			<div class="share_sub f-16 montserLight ys-66 wow fadeInUp B-300" data-wow-delay=".1s">The best content is authentic and useful. Explore these four content pillars <br/>with reference to GoodWe.</div>
			<div class="share_link f-16 montserRegular wow fadeInUp" data-wow-delay=".2s">
			View Technical Specs 
			<img  :src="require('@/assets/pc/share/jiantou.png')" style="width:0.11rem;height: 0.11rem;" alt="" />
			</div>
			<div class="share_cards flex">
				<div class="share_card wow fadeInUp" data-wow-delay=".2s" v-for="(c,i) in cards" :key="i" :class="{active: c.active}">
					<div class="card_icon_circle">
						<svg v-if="c.svg === 'person'" class="card_icon person" viewBox="0 0 24 24" fill="none"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#e60012"/></svg>
						<img v-else :src="c.icon" class="card_icon" alt="" />
					</div>
					<div class="card_title B-500 f-20 montserMedium">{{c.title}}</div>
					<div class="card_desc B-300 f-16 montserLight">{{c.desc}}</div>
				</div>
			</div>
		</div>

		<!-- ========== Section 4: Check Out Similar Videos ========== -->
		<div class="video_section"  :style="'background: url('+require('@/assets/pc/share/gezi.png')+') no-repeat center/cover'">
			<div class="video_title B-500 f-48 montserMedium ys-33 wow fadeInUp">Check Out Similar Videos</div>
			<div class="video_sub f-16 montserLight ys-66 wow fadeInUp" data-wow-delay=".1s">See how other Ambassadors are sharing their expertise.</div>
			<div class="video_cards flex">
				<div class="video_card wow fadeInUp" data-wow-delay=".2s" v-for="(v,i) in videos" :key="i">
					<div class="video_thumb">
						<img :src="v.img" class="video_img" alt="" />
						<div class="video_play">
							<!-- <svg viewBox="0 0 24 24" fill="none"><path d="M9 8l7 4-7 4V8z" fill="#DA0007"/></svg> -->
							<img style="width: 13.5px;height: 15px;" :src="require('@/assets/pc/share/播放2.png')" alt="" />
						</div>
					</div>
					<div class="video_name B-500 f-22 montserMedium ys-33">{{v.name}}</div>
					<div class="video_cat f-16 montserLight">{{v.cat}}</div>
				</div>
			</div>
		</div>

		<!-- ========== Section 5: Submission Checklist ========== -->
		<div class="check_section">
			<div class="check_card" :style="'background: url('+require('@/assets/pc/share/bg3.png')+') no-repeat center/cover'">
				<div class="check_left">
					<div class="check_title B-500 f-48 montserMedium ys-33 wow fadeInUp">Submission<br/>Checklist</div>
					<div class="check_desc f-16 montserLight ys-66 wow fadeInUp" data-wow-delay=".1s">Your submission must meet the applicable originality and content requirements. To qualify, your video should:</div>
				</div>
				<div class="check_right">
					<div class="check_item wow fadeInUp" data-wow-delay=".2s" v-for="(t,i) in checks" :key="i">
						<div class="check_circle">
							<img :src="require('@/assets/pc/share/对号@2x.png')" class="check_icon" alt="" />
						</div>
						<span class="check_text f-16 montserLight ys-33">{{t}}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- ========== Section 6: Before You Submit ========== -->
		<div class="submit_section"  :style="'background: url('+require('@/assets/pc/share/dibubg1.png')+') no-repeat center/cover'">
			<div class="submit_title B-500 f-48 montserMedium wow fadeInUp">Before You Submit Your Video</div>
			<div class="submit_sub f-16 montserLight wow fadeInUp" data-wow-delay=".1s">Review specs and pick your social platform before uploading</div>
			<div class="submit_content flex">
				<div class="submit_left wow fadeInUp" data-wow-delay=".2s" :style="'background: url('+require('@/assets/pc/share/bg4.png')+') no-repeat center/cover'">
					<div class="req_title B-500 f-24 montserMedium">Video Requirements</div>
					<div class="req_item"  style="margin-bottom: .65rem;">
						<img :src="require('@/assets/pc/share/shizhongx.png')" class="req_icon" alt="" />
						<div class="req_info">
							<div class="req_label f-14 montserLight">RECOMMENDED LENGTH</div>
							<div class="req_value B-400 f-25 montserRegular">30 seconds – 3 minutes</div>
							<div class="req_tip f-14 montserLight">Suitable for project showcase & technical sharing</div>
						</div>
					</div>
					<!-- <div class="req_line"></div> -->
					<div class="req_item">
						<img :src="require('@/assets/pc/share/duihao.png')" class="req_icon" alt="" />
						<div class="req_info">
							<div class="req_label f-14 montserLight">PREFERRED FORMAT</div>
							<div class="req_value B-400 f-25 montserRegular">1080p Minimum (MP4)</div>
							<div class="req_tip f-14 montserLight">Ensure stable image and clear audio</div>
						</div>
					</div>
				</div>
				<div class="submit_right">
					<div class="plat_title B-600 f-24 montserBold wow fadeInUp mt-26" data-wow-delay=".3s">Eligible Platforms</div>
					<div class="plat_grid">
						<div class="plat_card wow fadeInUp" data-wow-delay=".3s" v-for="(p,i) in platforms" :key="i">
						<!-- <svg v-if="p.svg === 'instagram'" class="plat_icon" viewBox="0 0 24 24" fill="none"><path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.054 1.805.248 2.227.415.56.217.96.477 1.38.897.42.42.68.82.897 1.38.167.422.361 1.057.415 2.227.058 1.266.07 1.65.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.248 1.805-.415 2.227a3.7 3.7 0 0 1-.897 1.38 3.7 3.7 0 0 1-1.38.897c-.422.167-1.057.361-2.227.415-1.266.058-1.65.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.805-.248-2.227-.415a3.7 3.7 0 0 1-1.38-.897 3.7 3.7 0 0 1-.897-1.38c-.167-.422-.361-1.057-.415-2.227C2.212 15.584 2.2 15.2 2.2 12s.012-3.584.07-4.85c.054-1.17.248-1.805.415-2.227.217-.56.477-.96.897-1.38.42-.42.82-.68 1.38-.897.422-.167 1.057-.361 2.227-.415C8.416 2.212 8.8 2.2 12 2.2zm0 1.8c-3.15 0-3.5.012-4.74.068-1.07.05-1.65.23-2.038.38-.435.17-.745.375-1.13.76-.385.385-.59.695-.76 1.13-.15.388-.33.968-.38 2.038C2.812 8.5 2.8 8.85 2.8 12s.012 3.5.068 4.74c.05 1.07.23 1.65.38 2.038.17.435.375.745.76 1.13.385.385.695.59 1.13.76.388.15.968.33 2.038.38C8.5 21.188 8.85 21.2 12 21.2s3.5-.012 4.74-.068c1.07-.05 1.65-.23 2.038-.38.435-.17.745-.375 1.13-.76.385-.385.59-.695.76-1.13.15-.388.33-.968.38-2.038.056-1.24.068-1.59.068-4.74s-.012-3.5-.068-4.74c-.05-1.07-.23-1.65-.38-2.038a3.15 3.15 0 0 0-.76-1.13 3.15 3.15 0 0 0-1.13-.76c-.388-.15-.968-.33-2.038-.38C15.5 4.012 15.15 4 12 4zm0 3.065A4.935 4.935 0 1 1 12 16.935 4.935 4.935 0 0 1 12 7.065zm0 1.8A3.135 3.135 0 1 0 12 15.135 3.135 3.135 0 0 0 12 8.865zm5.135-2.06a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3z" fill="white"/></svg> -->
						<!-- <svg v-else-if="p.svg === 'linkedin'" class="plat_icon" viewBox="0 0 24 24" fill="none"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" fill="white"/></svg> -->
						<img :src="p.icon" :class="'plat_icon'+i" alt=""/>
						<span class="plat_name f-16 montserLight">{{p.name}}</span>
					</div>
					</div>
					<div class="submit_note wow fadeInUp" data-wow-delay=".4s">
						<img :src="require('@/assets/pc/share/gantan.png')" class="note_icon_s" alt="" />
						<div class="note_text">
							<span class="montserBold">Important: </span>
							<span class="f-16 montserLight">All videos must be set to Public so our team can access and review the content for point distribution.</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ========== Section 7: FAQ ========== -->
		<div class="faq_section">
			<div class="faq_title B-600 f-48 montserBold ys-33 wow fadeInUp">Frequently Asked Questions</div>
			<div class="faq_list">
				<div class="faq_item wow fadeInUp" data-wow-delay=".1s" v-for="(f,i) in faqs" :key="i">
					<div class="faq_q flex j-between a-center">
						<span class="f-18 montserMedium ys-33">{{f.q}}</span>
						<span class="faq_icon B-600 f-36 montserBold" :class="{open: f.open}">{{f.open ? '−' : '+'}}</span>
					</div>
					<div class="faq_a f-16 montserLight ys-66" v-if="f.open">{{f.a}}</div>
					<div class="faq_line"></div>
				</div>
			</div>
		</div>

		<!-- ========== Section 8: CTA ========== -->
		<div class="cta_section">
			<div class="cta_card wow fadeInUp" :style="'background: url('+require('@/assets/pc/share/bg5.png')+') no-repeat center/cover'">
				<div class="cta_title B-600 f-48 montserBold">Ready to Share Your Expertise?</div>
				<div class="cta_sub f-18 montserLight">Submit your link now and get your 500 GoodWe PLUS+<br/>points upon approval.</div>
				<div class="cta_btn">
					<svg class="cta_icon" viewBox="0 0 24 24" fill="none"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
					<span class="f-16 montserMedium">SUBMIT VIDEO LINK</span>
				</div>
				<div class="cta_contact f-16 montserLight">
					Questions? Contact the GoodWe Plus Team<br/>
					<span class="B-600">goodwe.plus@goodwe.com</span>
				</div>
			</div>
		</div>

		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import video1 from '@/assets/pc/share/video1.png'
	import video2 from '@/assets/pc/share/video2.png'
	import video3 from '@/assets/pc/share/video3.png'
	export default {
		created() {
		},
		mounted() {
			new this.$wow.WOW({ live: false }).init()
		},
		components: {
			Tou,
			Foot,
		},
		data() {
			return {
				steps: [
					{ num: 'STEP 01', title: 'Create', desc: 'Create original video content featuring GoodWe solutions or expertise.', icon: require('@/assets/pc/share/上传视频 (1)@2x.png') },
					{ num: 'STEP 02', title: 'Share', desc: 'Post your video on an eligible social-media platform.', icon: require('@/assets/pc/share/分享@2x.png') },
					{ num: 'STEP 03', title: 'Submit', desc: 'Send us your link through the submission form.', icon: require('@/assets/pc/share/提交@2x.png') },
					{ num: 'STEP 04', title: 'Earn', desc: '500 points credited to your account upon approval.', icon: require('@/assets/pc/share/积分@2x.png') },
				],
				cards: [
					{ title: 'Product Spotlight', desc: 'Showcase a GoodWe product and explain what makes it useful to your customers.', icon: require('@/assets/pc/share/【产品亮点】四化管理@2x.png'), active: false },
					{ title: 'Installation Insights', desc: 'Share practical installation knowledge, tips, and best practices from the field.', icon: require('@/assets/pc/share/数据模型安装@2x.png'), active: false },
					{ title: 'Your Experience', desc: 'Talk about your experience working with GoodWe products and support solutions.', icon: require('@/assets/pc/share/jinyan.png'), svg: '', active: false },
					{ title: 'Education', desc: 'Help your audience better understand solar, storage, and energy management.', icon: require('@/assets/pc/share/教育@2x.png'), active: false },
				],
				videos: [
					{ name: 'ESA Series Setup Guide', cat: 'Installation Insights', img: video1 },
					{ name: 'Why We Choose GoodWe', cat: 'Experience', img: video2 },
					{ name: 'Smart Energy Solutions 101', cat: 'Educational', img: video3 },
				],
				checks: [
					'Feature GoodWe products, solutions or relevant expertise',
					'Provide useful promotional or educational content',
					'Contain accurate product information',
					'Be original and legally compliant',
					'Be published through an eligible social-media platform',
					'Meet all applicable Ambassador Activity requirements',
				],
				platforms: [
					{ name: 'Instagram', icon:require('@/assets/pc/share/instagram.png'), svg: 'instagram' },
					{ name: 'TikTok', icon: require('@/assets/pc/share/tiktok.png'), svg: '' },
					{ name: 'LinkedIn', icon: require('@/assets/pc/share/linkedin.png'), svg: '' },
					{ name: 'YouTube', icon: require('@/assets/pc/share/youtube.png'), svg: '' },
					{ name: 'Facebook', icon: require('@/assets/pc/share/facebook.png'), svg: '' },
				],
				faqs: [
					{ q: 'Who can participate in the Ambassador Benefit?', a: 'The Ambassador Benefit is available to eligible GoodWe PLUS+ Members. Participation in each Ambassador Activity is subject to the specific eligibility requirements published by GoodWe.', open: true },
					{ q: 'What type of videos can I submit?', a: '', open: false },
					{ q: 'How many points can I earn?', a: '', open: false },
					{ q: 'What social-media platforms are eligible?', a: '', open: false },
					{ q: 'What are the video requirements?', a: '', open: false },
				],
			}
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.Sharebox{
		background-color: #FFFFFF !important;
		box-sizing: border-box;
		* , *::before, *::after{ box-sizing: border-box; }
		div {
		    margin: 0; // 清除外边距
		    line-height: 1; // 临时覆盖ys-33，测试看效果；如果ys-33是固定行高就改这个
		  }
		// ===== Banner =====
		.Sharebox_top{
			position: relative;
			width: 100%;
			height: 8.92rem;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: flex-start;
		}
		.Sharebox_top_inner{
			display: flex;
			align-items: flex-start;
			width: 13.97rem;
			position: relative;
		}
		.Sharebox_top_left{
			position: relative;
			padding-top: 1.4rem;
			width: 6.5rem;
			flex-shrink: 0;
			z-index: 2;
		}
		.Sharebox_top_left_btn{
			width: 1.97rem;
			height: 0.43rem;
			background: #fee8e4;
			line-height: 0.43rem;
			border-radius: 0.215rem;
			color: #E60012;
			margin-bottom: 0.21rem;
			span{
				font-size: 0.16rem;
				font-family: "montserMedium";
				color: #E60012;
			}
		}
		.Sharebox_top_left_title{ color: #E60010; white-space: nowrap; }
		.Sharebox_top_line{
			display: block;
			line-height: 0.91;
			letter-spacing: -0.02em;
		}
		.Sharebox_btn{ text-align: center; }
		.Sharebox_top_left_desc{
			margin-top: 0.53rem;
			div{ line-height: 0.3rem; color: #666; }
		}
		.Sharebox_top_submit{
			display: flex;
			align-items: center;
			justify-content: center;
			width: 2.57rem;
			height: 0.65rem;
			margin-top: 0.71rem;
			background: linear-gradient(to right, #ff765a, #e71118);
			border-radius: 0.34rem;
			cursor: pointer;
			.submit_icon{
				width: 0.25rem;
				height: 0.25rem;
				margin-right: 0.12rem;
			}
			.submit_text{
				font-size: 0.17rem;
				color: #ffffff;
				font-family: "montserMedium";
			}
		}
		.Sharebox_top_note{
			display: flex;
			align-items: center;
			margin-top: 0.39rem;
			.note_icon{
				width: 0.21rem;
				height: 0.21rem;
				margin-right: 0.1rem;
				flex-shrink: 0;
			}
			.note_text{
				font-size: 0.16rem;
				color: #333;
			}
		}
		.Sharebox_top_right{
			position: relative;
			margin-left: 0.29rem;
			margin-top: 1.91rem;
			width: 7.18rem;
			height: 7.01rem;
			flex-shrink: 0;
			z-index: 1;
			.banner_img{ width: 100%; height: 100%; object-fit: contain; }
		}

		// ===== Common =====
		.flex{ display: flex; }
		.j-between{ justify-content: space-between; }
		.a-center{ align-items: center; }

		// ===== Section 2: How It Works =====
		.how_section{
			padding: 0.6rem 0 0.8rem;
			text-align: center;
		}
		.how_tag{
			display: inline-block;
			width: 1.42rem;
			height: 0.43rem;
			line-height: 0.43rem;
			background: #FFF1EE;
			border-radius: 0.2rem;
			margin-bottom: 0.16rem;
			span{ font-size: 0.15rem; color: #E60012;}
		}
		.how_title{
			font-size: 0.48rem;
			margin-bottom: 0.69rem;
		}
		.how_steps{
			justify-content: center;
			gap: 0.3rem;
		}
		.how_step{
			width: 2.8rem;
		}
		.step_circle{
			width: 1.10rem;
			height: 1.10rem;
			border-radius: 50%;
			background: #fff;
			margin: 0 auto 0.2rem;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 3px 1px 24px 0px rgba(168,28,32,0.07);
			box-sizing: border-box;
		}
		.step_icon0{
			width: 0.37rem;
			height: 0.25rem;
			object-fit: contain;
		}
		.step_icon1{
			width: 0.36rem;
			height: 0.35rem;
			object-fit: contain;
		}
		.step_icon2{
			width: 0.39rem;
			height: 0.37rem;
			object-fit: contain;
		}
		.step_icon3{
			width: 0.30rem;
			height: 0.32rem;
			object-fit: contain;
		}
		.step_num{
			font-size: 0.15rem;
			color: #E60012;
			letter-spacing: 0.02em;
			margin-bottom: 0.16rem;
		}
		.step_title{
			font-size: 0.22rem;
			margin-bottom: 0.20rem;
		}
		.step_desc{
			font-size: 0.16rem;
			line-height: 0.24rem;
		}

		// ===== Section 3: What Can You Share? =====
		.share_section{
			padding: 0.85rem 0 1.16rem;
			text-align: center;
		}
		.share_title{
			font-size: 0.48rem;
			margin-bottom: 0.15rem;
		}
		.share_sub{
			font-size: 0.16rem;
			line-height: 0.24rem;
			margin-bottom: 0.4rem;
		}
		.share_link{
			color: #e60010;
			cursor: pointer;
			margin-bottom: 0.5rem;
			.arrow{ margin-left: 0.05rem; }
		}
		.share_cards{
			justify-content: center;
			gap: 0.21rem;
		}
		.share_card{
			width: 2.82rem;
			height: 3.04rem;
			// background: #fff;
			border-radius: 0.2rem;
			padding: 0.45rem 0.25rem;
			text-align: left;
			border: 1px solid #DBDBDB;
			box-sizing: border-box;
			transition: all .3s;
			cursor: pointer;
			&.active, &:hover{
				background: linear-gradient(135deg, #ff765a, #e71118);
				transform: translateY(-0.08rem);
				box-shadow: 0 0.1rem 0.25rem rgba(231,17,24,0.25);
				.card_title, .card_desc{ color: #fff; }
				.card_icon_circle{ background:#fff;border: none; }
				.card_icon.person path{ fill: #fff; }
				// .card_icon:not(.person){ filter: brightness(0) invert(1); }
			}
		}
		.card_icon_circle{
			width: 0.52rem;
			height: 0.52rem;
			border-radius: 50%;
			border: 1px solid #FFB5B0;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 0.35rem;
		}
		.card_icon{
			width: 0.21rem;
			height: 0.21rem;
			object-fit: contain;
			transition: filter .3s;
		}
		.card_title{
			font-size: 0.2rem;
			color: #333;
			margin-bottom: 0.15rem;
		}
		.card_desc{
			font-size: 0.16rem;
			color: #666;
			line-height: 0.24rem;
		}

		// ===== Section 4: Videos =====
		.video_section{
			padding: 1.24rem 0 1.58rem 0;
			text-align: center;
		}
		.video_title{
			font-size: 0.48rem;
			margin-bottom: 0.23rem;
		}
		.video_sub{
			font-size: 0.16rem;
			margin-bottom: 0.7rem;
		}
		.video_cards{
			justify-content: center;
			gap: 0.2rem;
		}
		.video_card{
			width: 3.86rem;
			// background: #fff;
			border-radius: 0.2rem;
			overflow: hidden;
			box-shadow: 0px 0px 54px 0px rgba(145,145,145,0.17);
			border: 0.01px solid #DADADA;
			box-sizing: border-box;
			text-align: left;
			transition: all .3s;
			cursor: pointer;
			&:hover{
				transform: scale(1.05);
				box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,0.15);
				// .video_img{ transform: scale(1.08); }
				// .video_play{ background: #FFFFFF; }
			}
		}
		.video_thumb{
			padding:.26rem .2rem;
			position: relative;
			width: 100%;
			// height: 2.4rem;
			overflow: hidden;
		}
		.video_img{
			width: 100%;
			height: 2.12rem;
			border-radius: 0.08rem;
			object-fit: cover;
			transition: transform .3s;
		}
		.video_play{
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			width: 0.69rem;
			height: 0.69rem;
			border-radius: 50%;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background .3s;
			// svg{ width: 0.3rem; height: 0.3rem; }
		}
		.video_name{
			font-size: 0.22rem;
			padding: 0.1rem 0.2rem 0.18rem;
		}
		.video_cat{
			font-size: 0.16rem;
			color: #6C6C6C;
			padding: 0 0.2rem 0.56rem 0.2rem;
		}

		// ===== Section 5: Submission Checklist =====
		.check_section{
			padding: 0.4rem 0 1.62rem 0.4rem ;
		}
		.check_card{
			width: 12.04rem;
			padding: 1.1rem 0.84rem 0.83rem 0.71rem;
			// height: 6.57rem;
			margin: 0 auto;
			border-radius: 0.2rem;
			display: flex;
			overflow: hidden;
			justify-content: space-between;
		}
		.check_left{
			width: 4.5rem;

		}
		.check_title{
			font-size: 0.48rem;
			line-height: 1.1;
			margin-bottom: 0.3rem;
		}
		.check_desc{
			font-size: 0.16rem;
			line-height: 0.24rem;
			color: #666;
		}
		.check_right{
			// flex: 1;
			// padding: 0rem 0.5rem 0 0;
		}
		.check_item{
			display: flex;
			align-items: center;
			margin-bottom: 0.35rem;
		}
		.check_circle{
			width: 0.41rem;
			height: 0.41rem;
			border-radius: 50%;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 0.15rem;
			flex-shrink: 0;
			box-shadow: 0 0.01rem 0.05rem rgba(0,0,0,0.08);
			box-sizing: border-box;
		}
		.check_icon{
			width: 0.12rem;
			height: 0.10rem;
		}
		.check_text{
			font-size: 0.16rem;
			color: #3d3d3d;
		}

		// ===== Section 6: Before You Submit =====
		.submit_section{
			// background: #3a3a3a;
			padding: 0.94rem 0 1.21rem;
			text-align: center;
			color: #fff;
		}
		.submit_title{
			font-size: 0.48rem;
			color: #fff;
			margin-bottom: 0.12rem;
		}
		.submit_sub{
			font-size: 0.16rem;
			color: #fff;
			margin-bottom: 0.9rem;
		}
		.submit_content{
			width: 12rem;
			margin: 0 auto;
			gap: 0.4rem;
			text-align: left;
		}
		.submit_left{
			width: 4.7rem;
			height: 3.68rem;
			border-radius: 0.10rem;
			padding:0.61rem 0.42rem  0.23rem 0.35rem;
			color: #fff;
		}
		.req_title{
			font-size: 0.24rem;
			color: #fff;
			margin-bottom: 0.3rem;
		}
		.req_item{
			display: flex;
			align-items: flex-start;
			margin-bottom: 0.25rem;
		}
		.req_icon{
			width: 0.31rem;
			height: 0.31rem;
			margin-right: 0.09rem;
			flex-shrink: 0;
		}
		.req_label{
			font-size: 0.14rem;
			color: #fff;
			opacity: 0.8;
			margin-bottom: 0.04rem;
		}
		.req_value{
			font-size: 0.25rem;
			color: #fff;
			margin-bottom: 0.05rem;
		}
		.req_tip{
			font-size: 0.14rem;
			color: #fff;
			opacity: 0.7;
		}
		.req_line{
			height: 0.01rem;
			background: rgba(255,255,255,0.1);
			margin: 0.2rem 0;
		}
		.submit_right{
			flex: 1;
		}
		.plat_title{
			font-size: 0.24rem;
			color: #fff;
			margin-bottom: 0.3rem;
		}
		.plat_grid{
			display: grid;
			grid-template-columns: repeat(3, 2.08rem);
			gap: 0.2rem;
			margin-bottom: 0.67rem;
		}
		.plat_card{
			position: relative;
			height: 0.72rem;
			background: rgba(255,255,255,0.1);
			border-radius: 0.08rem;
			display: flex;
			align-items: center;
			padding: 0 0.2rem;
			gap: 0.12rem;
			overflow: hidden;
			cursor: pointer;
			// 边框层：默认左黑右白渐变
			&::before{
				content: '';
				position: absolute;
				inset: 0;
				background: linear-gradient(111deg, #000000, #FFFFFF);
				transition: background .3s;
			}
			// 内部背景层（覆盖中间，仅留1px边框）
			&::after{
				content: '';
				position: absolute;
				inset: 1px;
				border-radius: 0.07rem;
				background: rgba(255,255,255,0.1);
			}
			// 悬停：流动光带动画
			&:hover::before{
				background: conic-gradient(from 0deg, transparent 0%, rgba(255,255,255,0.9) 8%, transparent 18%, transparent 100%);
				animation: platBorderFlow 2.5s linear infinite;
			}
			> *{
				position: relative;
				z-index: 1;
			}
		}
		@keyframes platBorderFlow{
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.plat_icon0{
			width: 0.28rem;
			height: 0.28rem;
			object-fit: contain;
		}
		.plat_icon1{
			width: 0.27rem;
			height: 0.3rem;
			object-fit: contain;
		}
		.plat_icon2{
			width: 0.25rem;
			height: 0.24rem;
			object-fit: contain;
		}
		.plat_icon3{
			width: 0.23rem;
			height: 0.29rem;
			object-fit: contain;
		}
		.plat_icon4{
			width: 0.3rem;
			height: 0.3rem;
			object-fit: contain;
		}
		.plat_name{
			font-size: 0.16rem;
			color: #fff;
		}
		.submit_note{
			display: flex;
			align-items: flex-start;
			gap: 0.1rem;
			color: #fff;
			.note_icon_s{
				width: 0.23rem;
				height: 0.23rem;
				flex-shrink: 0;
				margin-top: 0.02rem;
			}
			.note_text{
				flex: 1;
				line-height: 0.24rem;
			}
		}

		// ===== Section 7: FAQ =====
		.faq_section{
			padding: 0.8rem 0 0.8rem;
			background: #f0f0f0;
		}
		.faq_title{
			font-size: 0.48rem;
			text-align: center;
			margin-bottom: 0.6rem;
		}
		.faq_list{
			width: 9rem;
			margin: 0 auto;
		}
		.faq_item{
			margin-bottom: 0.1rem;
		}
		.faq_q{
			padding: 0.2rem 0;
			cursor: pointer;
		}
		.faq_icon{
			color: #dc2626;
			font-size: 0.36rem;
			line-height: 1;
			&.open{ font-size: 0.44rem; }
		}
		.faq_a{
			font-size: 0.16rem;
			line-height: 0.25rem;
			color: #666;
			padding-bottom: 0.2rem;
		}
		.faq_line{
			height: 0.01rem;
			background: #e1e1e1;
		}

		// ===== Section 8: CTA =====
		.cta_section{
			padding: 0.6rem 0 0.8rem;
			text-align: center;
		}
		.cta_card{
			width: 12rem;
			height: 5.6rem;
			margin: 0 auto;
			border-radius: 0.2rem;
			padding-top: 0.8rem;
			color: #fff;
			box-shadow: 0 0.1rem 0.4rem rgba(0,0,0,0.15);
		}
		.cta_title{
			font-size: 0.48rem;
			color: #fff;
			margin-bottom: 0.2rem;
		}
		.cta_sub{
			font-size: 0.18rem;
			color: #fff;
			line-height: 0.28rem;
			margin-bottom: 0.4rem;
		}
		.cta_btn{
			display: inline-flex;
			align-items: center;
			justify-content: center;
			height: 0.57rem;
			padding: 0 0.4rem;
			background: #131313;
			border-radius: 0.285rem;
			cursor: pointer;
			margin-bottom: 0.5rem;
			.cta_icon{
				width: 0.22rem;
				height: 0.22rem;
				margin-right: 0.1rem;
			}
			span{ color: #fff; font-size: 0.16rem; }
		}
		.cta_contact{
			font-size: 0.16rem;
			color: #fff;
			line-height: 0.22rem;
		}
	}

	// ===== Mobile 750 =====
	@media (max-width: 752px) {
		.Sharebox{
			.Sharebox_top{
				height: auto;
				padding-bottom: 0.6rem;
				background-size: 200% auto;
			}
			.Sharebox_top_inner{
				flex-direction: column;
				width: 100%;
			}
			.Sharebox_top_left{
				margin-left: 0.3rem;
				margin-right: 0.3rem;
				padding-top: 0.5rem;
				width: auto;
			}
			.Sharebox_top_left_btn{
				width: 1.97rem;
				height: 0.43rem;
				line-height: 0.43rem;
				span{ font-size: 0.16rem; }
			}
			.Sharebox_top_left_titles .Sharebox_top_line{
				font-size: 0.5rem !important;
				line-height: 0.95;
			}
			.Sharebox_top_left_desc{
				margin-top: 0.3rem;
				div{ font-size: 0.14rem !important; line-height: 0.26rem; }
			}
			.Sharebox_top_submit{
				width: 2.57rem;
				height: 0.65rem;
				margin-top: 0.4rem;
				.submit_text{ font-size: 0.15rem; }
			}
			.Sharebox_top_note{
				margin-top: 0.25rem;
				.note_text{ font-size: 0.13rem; }
			}
			.Sharebox_top_right{
				position: relative;
				left: auto; top: auto;
				width: 100%;
				height: auto;
				margin-left: 0;
				margin-top: 0.4rem;
				padding: 0 0.3rem;
				.banner_img{ width: 100%; height: auto; }
			}

			.how_steps{ flex-direction: column; align-items: center; }
			.how_step{ width: 80%; margin-bottom: 0.4rem; }
			.how_title{ font-size: 0.36rem !important; }

			.share_cards{ flex-direction: column; align-items: center; }
			.share_card{ width: 85%; height: auto; }
			.share_title{ font-size: 0.36rem !important; }

			.video_cards{ flex-direction: column; align-items: center; }
			.video_card{ width: 85%; }
			.video_title{ font-size: 0.36rem !important; }

			.check_card{
				width: 92%;
				height: auto;
				flex-direction: column;
				padding: 0.4rem;
			}
			.check_left{ width: 100%; padding: 0; margin-bottom: 0.3rem; }
			.check_right{ padding: 0; }
			.check_title{ font-size: 0.36rem !important; }

			.submit_content{
				width: 92%;
				flex-direction: column;
			}
			.submit_left{ width: 100%; height: auto; }
			.plat_grid{ grid-template-columns: repeat(2, 1fr); }
			.submit_title{ font-size: 0.36rem !important; }

			.faq_list{ width: 90%; }
			.faq_title{ font-size: 0.36rem !important; }

			.cta_card{
				width: 92%;
				height: auto;
				padding: 0.6rem 0.3rem;
			}
			.cta_title{ font-size: 0.36rem !important; }
		}
	}
</style>
